
import { ErrorMessage } from '../utils/Messages';
import SwalServices from '../services/swalServices/SwalServices';
import UserServices from '../services/axiosServices/apiServices/UserServices';
import VendorServices from '../services/axiosServices/apiServices/VendorServices';
import AccountServices from '../services/axiosServices/apiServices/AccountServices';
import EmailTemplateServices from '../services/axiosServices/apiServices/EmailTemplateServices';
import EmailConfigurationServices from '../services/axiosServices/apiServices/EmailConfigurationServices';
import SetSystemConfigurationServices from '../services/axiosServices/apiServices/SetSystemConfigurationServices';
import ProductService from '../services/axiosServices/apiServices/ProductServices';
import VendorGroupServices from '../services/axiosServices/apiServices/VendorGroupServices';
import MasterVendorServices from '../services/axiosServices/apiServices/MasterVendorServices';
import InquiryProductServices from '../services/axiosServices/apiServices/InquiryProductServices';
import InquiryEmailService from '../services/axiosServices/apiServices/InquiryEmailService';
import VendorPreferenceServices from '../services/axiosServices/apiServices/VendorPreferenceServices';
import InquiryResponseServices from '../services/axiosServices/apiServices/InquiryResponseServices';
import InquiryResponseProductQuantityServices from '../services/axiosServices/apiServices/InquiryResponseProductQuantityServices';
import InquiryResponseProductDetailServices from '../services/axiosServices/apiServices/InquiryResponseProductDetailServices';
import EmailLogsServices from '../services/axiosServices/apiServices/EmailLogsServices';
//**
export default class APISererviceManager {

  swalServices = new SwalServices();
  userServices = new UserServices();
  setSystemConfigurationServices = new SetSystemConfigurationServices();
  vendorServices = new VendorServices();
  vendorGroupServices = new VendorGroupServices();
  accountServices = new AccountServices();
  emailTemplateServices = new EmailTemplateServices();
  emailConfigServices = new EmailConfigurationServices();
  productService = new ProductService();
  masterVendorServices = new MasterVendorServices();
  inquiryProductServices = new InquiryProductServices();
  inquiryEmailService = new InquiryEmailService();
  vendorPreferenceServices = new VendorPreferenceServices();
  inquiryResponseServices = new InquiryResponseServices();
  inquiryResponseProductQuantityServices = new InquiryResponseProductQuantityServices();
  inquiryResponseProductDetailServices = new InquiryResponseProductDetailServices();
  emailLogsServices=new EmailLogsServices();

  constructor() { }

  onAPICall(key, apiFun, data, onCallBack, onUpdateState, getRequest) {
    if (key === 'getRequest' && data.searchText !== '') {
      onUpdateState({ "setIsLoad": false });
    }
    else {
      onUpdateState({ "setIsLoad": true, "btnLoading": true });
    }
        apiFun(data).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        onCallBack(key, true, response.responseItem.responseContent, getRequest);
      }
      else if (response.statusCode === 401) {
        onCallBack(key, true, response.responseItem.responseContent, getRequest);
    }
       else {
        onCallBack(key, false, {});
        if (key === 'login') {
          onUpdateState({ "setIsLoad": false, "btnLoading": false });
          this.swalServices.Toaster(ErrorMessage.InvalidAuthorization);
        }
        else {
          onUpdateState({ "setIsLoad": false, "btnLoading": false });
          this.swalServices.Error(response.message);
        }
      }
    })
      .catch((error) => {
        // Handle network errors or other exceptions
        this.swalServices.Error("Oops! Something went wrong while fetching data from the server. Please try again later.");
        onUpdateState({ "setIsLoad": false, "btnLoading": false });
      });
  }
}
